import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useState } from "react";
import { editAppeal } from "services/advocateComplaintService";
import { AdvocateComplaints, Appeal } from "types";
import { LoadingIcon } from "utils/constant";
import { useTranslation } from "contexts/i18nContext";
import "../../complaintRequest/styles/AddEvidenceModal.css";

interface ModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  complaintData: AdvocateComplaints;
  appealData: Appeal;
  onRefresh: any;
}

export default function AddAppealRegistrationModalForwardToCouncilOffice({
  isOpen,
  setIsOpen,
  complaintData,
  appealData,
  onRefresh,
}: ModalProps) {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [success, setSuccess] = useState(false);

  const [formState, setFormState] = useState({
    registration_number: "",
    date: "",
  });

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!appealData) return;

    const data = {
      appeal_type: appealData?.appeal_type,
      memorandum_summary: appealData?.memorandum_summary,
      requesting_prosecutor: appealData?.requesting_prosecutor,
      registration_number: formState.registration_number,
      registration_date: formState.date,
      appeal_feedback_status: appealData?.appeal_feedback_status,
      // appeal_status:
      //   appealData?.appeal_type === APPEAL_TYPE.ACCUSED_PROSECUTOR_TO_COURT
      //     ? APPEAL_STATUS.FORWARDED_TO_REGISTRAR
      //     : APPEAL_STATUS.FORWARDED_TO_COUNCIL,
      discipline_case: appealData?.discipline_case || null,

      userid_requesting_prosecutor: appealData?.userid_requesting_prosecutor,
      admin_unit_id: complaintData?.admin_unit_id || "",
      org_id: complaintData?.org_id || "",
      accused_advocate_name: complaintData?.accused_name || "",
      user_id_accused_advocate: complaintData?.userid_accused_name || "",
      accused_license_number: complaintData?.accused_license_number || "",
    };
    const appeal_id = appealData?.id || "";
    const isFormData = false;

    setLoading(true);
    // setError(null);
    // setSuccess(false);
    try {
      await editAppeal(data, appeal_id, isFormData);

      onRefresh();
      setIsOpen(false);
      showToast(t("successfullyCreated"), "success");
      // setSuccess(true);
      setFormState({
        registration_number: "",
        date: "",
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
      // setError(
      // err?.response?.data?.message || err.message || "Something went wrong."
      // );
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t("addAppealRegistrationNo")}
    >
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("date")}
            </label>
            <input
              required
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
              type={"date"}
              name="date"
              placeholder={t("datePlaceholder")}
              value={formState.date ?? ""}
              onChange={handleChange}
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("registrationNo")}
            </label>
            <input
              required
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
              type="text"
              name="registration_number"
              placeholder={t("registrationPlaceholder")}
              value={formState.registration_number}
              onChange={handleChange}
            />
          </div>

          {/* <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("chargeFeedback")}
            </label>
            <textarea
              required
              rows={7}
              name="feedback"
              value={formState.feedback}
              onChange={handleChange}
              placeholder={t("detailsHere")}
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
            />
          </div> */}
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              {t("submitting")}
            </div>
          ) : (
            t("submit")
          )}
        </button>
      </form>
    </SideModal>
  );
}
